import * as THREE from 'three'

//Define scene
const scene = new THREE.Scene();
scene.background = new THREE.Color(0x000000);

const size = {
    width: window.innerWidth,
    height: window.innerHeight
}

console.log(size);

//CIRCLE1
//Define object GEOM + Material
const geometryC1 = new THREE.SphereGeometry( 0.3, 64, 32 );
const materialC1 = new THREE.MeshPhysicalMaterial( {color: 0xFFFFFF, emissive: 0x561029, roughness: 0, metalness: 0.5, reflectivity: 0.5 } );

const meshC1 = new THREE.Mesh(geometryC1, materialC1); //Combine geometry and material to a mesh
//scene.add(meshC1); //Add the mesh in the scene
meshC1.position.set(0,1,0);

//CIRCLE2
//Define object GEOM + Material
const geometryC2 = new THREE.SphereGeometry( 0.5, 64, 32 );
const materialC2 = new THREE.MeshPhysicalMaterial( {color: 0xFFFFFF, emissive: 0x561029, roughness: 0, metalness: 0.5, reflectivity: 0.5 } );

const meshC2 = new THREE.Mesh(geometryC2, materialC2); //Combine geometry and material to a mesh
//scene.add(meshC2); //Add the mesh in the scene
meshC2.position.set(0,0.25,0);

//CIRCLE3
//Define object GEOM + Material
const geometryC3 = new THREE.SphereGeometry( 0.9, 64, 32, 0, 6.28318, 0, 1.9 );
const materialC3 = new THREE.MeshPhysicalMaterial( {color: 0xFFFFFF, emissive: 0x561029, roughness: 0, metalness: 0.5, reflectivity: 0.5 } );

const meshC3 = new THREE.Mesh(geometryC3, materialC3); //Combine geometry and material to a mesh
//scene.add(meshC3); //Add the mesh in the scene
meshC3.position.set(0,-1.1,0);

const circles = new THREE.Group();
const meshes = [meshC1, meshC2, meshC3];

for (let i = 0; i < meshes.length; i++) {
    circles.add(meshes[i]);
  }

scene.add(circles);

//BAR1
const geometryB1 = new THREE.BoxGeometry( 0.1, 2, 0.1);
const materialB1 = new THREE.MeshPhysicalMaterial( {color: 0xf4f4f4, emissive: 0x561029, roughness: 0, metalness: 0.9, reflectivity: 0.9 } );

const meshB1 = new THREE.Mesh(geometryB1, materialB1); //Combine geometry and material to a mesh
//meshB1.scale.set(6,1,1);
// Calculate the position of meshC2
const positionC2 = meshC2.position.clone();

// Calculate the offset needed to align the centers of meshB1 and meshC2
const offsetX = positionC2.x - meshB1.position.x;
const offsetY = positionC2.y - meshB1.position.y;
const offsetZ = positionC2.z - meshB1.position.z;

// Apply the offset to align the centers
meshB1.position.x += offsetX;
meshB1.position.y += offsetY;
meshB1.position.z += offsetZ + 1;

meshB1.rotation.z = Math.PI / 4; // Rotate by 30 degrees

//BAR2
const meshB2 = meshB1.clone();
meshB2.rotation.z = meshB1.rotation.z + (Math.PI / 2);

// Adjust the position of meshB2, so it aligns correctly with meshB1
// You may need to fine-tune the position based on your scene setup
meshB2.position.x = meshB1.position.x;
meshB2.position.z = meshB1.position.z;

const bars = new THREE.Group();
scene.add(bars);
bars.add(meshB1);
bars.add(meshB2);

const textureLoader = new THREE.TextureLoader();
textureLoader.load('geometric-patterns-3.png',
 
    function (texture) {
        // Calculate aspect ratio of the texture
        const aspectRatio = texture.image.width / texture.image.height;

        // Create a plane with the loaded texture
        const planeGeometry = new THREE.PlaneGeometry(4.5 * aspectRatio, 4.5 * aspectRatio); // Adjust the size based on your needs
        const planeMaterial = new THREE.MeshPhysicalMaterial({ map: texture, side: THREE.DoubleSide });

        // Repeat the texture to fill the plane without stretching
        planeMaterial.map.wrapS = THREE.RepeatWrapping;
        planeMaterial.map.wrapT = THREE.RepeatWrapping;
        planeMaterial.map.repeat.set(1, aspectRatio);

        const plane = new THREE.Mesh(planeGeometry, planeMaterial);
        plane.position.y = 0;
        scene.add(plane);

        // Adjust the brightness by modifying the emissive color
        const brightnessFactor = 0.01; // Adjust this value to control brightness
        planeMaterial.emissive.setRGB(1, 1, 1).multiplyScalar(brightnessFactor);
    },
    function (xhr) {
        // On progress (optional)
        console.log((xhr.loaded / xhr.total * 100) + '% loaded');
    }
);

//Define camera properties and position
const width = size.width;
const height = size.height;
const camera = new THREE.PerspectiveCamera(75, width / height);
camera.position.z = 3;

//Add camera in the scene
scene.add(camera);

//Define light properties and add to scene
//const color = 0xFFFFFF;
const color = 0xFFFFFF;
const intensity = 0.2;
const light = new THREE.AmbientLight(color, intensity);
//scene.add(light);

//Define point light and add to scene
const pointLight = new THREE.PointLight(color, 1,10);
pointLight.position.set(2, 1.5, 3);
scene.add(pointLight);

const sphereSize = 1.5;
const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize);
scene.add(pointLightHelper);

//Add animation and renderer from the html file to visualise 
const canvas = document.querySelector("canvas.animation");
const renderer = new THREE.WebGLRenderer( {
    canvas: document.querySelector('canvas.animation')
});

const clock = new THREE.Clock();

//Rotation animation
function animate() {
    const elapsedTime = clock.getElapsedTime(); //Add time
    requestAnimationFrame(animate);

    //circles.rotation.x += 0.0005;
    //circles.rotation.y += 0.0005;

    // Use the elapsed time for dynamic random movement
    const positionRange = 0.1;  // Adjust the range
    const timeFactor = 0.0005;  // Adjust the time factor for the movement

    circles.rotation.x += Math.tan(elapsedTime * timeFactor + 0.005);
    circles.rotation.y += Math.sin(elapsedTime * timeFactor + 0.05);

    // Rotate the group containing meshB1 and meshB2 around the Z-axis
    bars.rotation.x += Math.sin(elapsedTime * timeFactor * 0.001);
    bars.rotation.y += Math.tan(elapsedTime * timeFactor + 0.005);
    bars.rotation.z += Math.sin(elapsedTime * timeFactor + 0.005);  // Adjust the rotation speed

    //circles.position.x = positionRange * (Math.sin(elapsedTime * timeFactor) + Math.random() - 0.5);
    //circles.position.y = positionRange * (Math.cos(elapsedTime * timeFactor) + Math.random() - 0.5);

    renderer.render(scene, camera);
}

//Set to be rendered size and objects
renderer.setSize(size.width, size.height);
renderer.render(scene, camera);
animate();

window.addEventListener('resize', () => {
    size.width = window.innerWidth;
    size.height = window.innerHeight;

    camera.aspect = size.width / size.height;
    camera.updateProjectionMatrix();

    renderer.setSize(size.width, size.height);
    renderer.render(scene, camera);
})
